import React from "react";
import { View } from "react-native";
import Icon, { IconName } from "./Icon";

const IconBackground = ({
    children,
    backgroundColor,
}: {
    children: React.ReactNode;
    backgroundColor?: string;
}) => {
    return (
        <View
            style={{
                backgroundColor: backgroundColor,
                height: 48,
                width: 48,
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
                flexDirection: "row",
            }}
        >
            {children}
        </View>
    );
};

type IconCompositionProps = {
    iconColor: string;
    backgroundColor: string;
    icon: IconName;
    size: number;
};

const IconComposition: React.FC<IconCompositionProps> = ({
    iconColor,
    backgroundColor,
    icon,
    size,
}) => {
    return (
        <IconBackground backgroundColor={backgroundColor}>
            <Icon name={icon} color={iconColor} size={size} />
        </IconBackground>
    );
};

export default IconComposition;
